module.exports = __webpack_public_path__ + "img/application_active.5804d61d.svg";